import {
    faTrophy,
    faGift,
    faShareAlt
} from '@fortawesome/free-solid-svg-icons';
import {
    faGem
} from '@fortawesome/free-regular-svg-icons';
import { HStack, Pressable } from 'native-base';
import { Caption } from './Typography';
import React, { ReactNode } from 'react';
import { I18nReacher } from '@springbig/shared';
import { PageHeaderConfig } from '@springbig/shared/src/settings/defaults';
import { useMenuStyles, useMilestonesStyles, useOffersStyles, useReferStyles, useSubscriptionsStyles } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { SpIcon } from './Icon';
import { useLocation } from 'react-router';

export type PageHeaderProps = {
    children?: ReactNode;
    config: PageHeaderConfig;
};

interface HeaderItem {
    icon: IconDefinition;
    textColor?: string;
    iconColor?: string;
}

const PageHeader = ({ config, children }: PageHeaderProps) => {

    const location = useLocation();
    const currentPath = location.pathname;
    const name = currentPath.split('/').slice(3).join('/');
    const { text: milestonesTextColor, icon: milestonesIconColor } = useMilestonesStyles();
    const { text: subscriptionsTextColor, icon: subscriptionsIconColor } = useSubscriptionsStyles();
    const { text: offersTextColor, icon: offersIconColor } = useOffersStyles();
    const { text: referTextColor, icon: referIconColor } = useReferStyles();
    const {
        icon,
        card_background,
        card_text
    } = useMenuStyles();

    const headerData: Record<string, HeaderItem> = {
        'milestones': {
            icon: faTrophy,
            textColor: milestonesTextColor,
            iconColor: milestonesIconColor,
        },
        'offers': {
            icon: faGift,
            textColor: offersTextColor,
            iconColor: offersIconColor,
        },
        'refer': {
            icon: faShareAlt,
            textColor: referTextColor,
            iconColor: referIconColor,
        },
        'subscriptions': {
            icon: faGem,
            textColor: subscriptionsTextColor,
            iconColor: subscriptionsIconColor,
        },
    };

    return (
        <HStack
            w={'100%'}
            bg={config.showBackButton ? card_background : {}}
            justifyContent={'space-between'}
            alignItems={'center'}
            p={4}
            space={2}
        >
            {config.showBackButton ? <Pressable onPress={() => window.history.back() }>
                <HStack alignItems='center'>
                    <FontAwesomeIcon
                        color={icon}
                        icon={faAngleLeft}
                    />
                    <Caption text='general.back' paddingX={2} color={card_text} />
                </HStack>
            </Pressable> : <></>}
            <HStack alignItems={'center'} space={2}>
                <Caption
                    color={headerData[name]?.textColor}
                    text={config.title as I18nReacher}
                />
                {headerData[name]?.icon ? <SpIcon
                    color={headerData[name]?.iconColor}
                    icon={headerData[name].icon}
                /> : <></>}
            </HStack>
            {children}
        </HStack>
    );
};

export default PageHeader;
